import axios from "axios";
import {convertSHA} from "./ExtracurricularCoursesToken"

export const GET_COURSES_BY_BADGE = "GET_COURSES_BY_BADGE";
export const GET_DEFINACION = "GET_DEFINACION";
export const GET_STUDENTS = "GET_STUDENTS";
export const UPDATE_STUDENTS = "UPDATE_STUDENTS";
export const CIN_LOADING = "CIN_LOADING";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL_EXTRACURRICULAR,
  withCredentials: false,
  headers: {
    'Access-Control-Allow-Origin' : '*',
    'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    }
});

export const GetCouresByBadge = (badge) => {
  var Token = convertSHA()
  return async dispatch => {
    // dispatch({
    //   type: CIN_LOADING
    // });
    await instance.get(`/Enrollment/GetListCoursesInstructor/${badge}&${Token}`).then((res => {
        dispatch({
            type: GET_COURSES_BY_BADGE,
            data: res.data
            })
      console.log("Resp", res);
      }
      )).catch(function(error){
        console.log("Error", error);
      });
  } 
};

  export const GetCouseScheduleById = (id) => {
    var Token = convertSHA()
    return async dispatch => {
      // dispatch({
      //   type: CIN_LOADING
      // });
      await instance.get(`/DefinitionCourse/GetDefinitionCourseById/${id}&${Token}`).then((res => {
          dispatch({
              type: GET_DEFINACION,
              data: res.data
              })
        console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };

  export const GetStudentsById = (id) => {
    var Token = convertSHA()
    return async dispatch => {
      // dispatch({
      //   type: CIN_LOADING
      // });
      await instance.get(`/Enrollment/GetListStudentsByCourse/${id}&${Token}`).then((res => {
          dispatch({
              type: GET_STUDENTS,
              data: res.data
              })
        console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };

  export const updateEmail = (student, user) =>{
    var Token = convertSHA()
    return async dispatch => {
      dispatch({
        type: CIN_LOADING
      });
      await instance.put(`/students/PutInsUpdtStudent/${student.id}&${student.badge}&${student.name}&${student.email}&true&${user}&${Token}` ).then((res => {
           dispatch({
               type: UPDATE_STUDENTS,
               data: res.data
           });
           console.log(res.data)
       })).catch(function(error){
         console.log("Error", error);
       });
   }
  }